import { type Dispatch, type SetStateAction, useEffect, useRef, useState } from 'react';

export function useFacetValue<T>(
  initialValues: T,
  defaultValue: T
): [T, Dispatch<SetStateAction<T>>] {
  const [currentValue, setCurrentValue] = useState<T>(initialValues ?? defaultValue);
  const previousInitialValues = useRef<T>(initialValues);

  useEffect(() => {
    const hasChanged = !areEqual(initialValues, previousInitialValues.current);

    if (hasChanged) {
      setCurrentValue(initialValues ?? defaultValue);
      previousInitialValues.current = initialValues;
    }
  }, [initialValues, defaultValue]);

  return [currentValue, setCurrentValue];
}

function areEqual<T>(a: T, b: T): boolean {
  if (a === b) return true;

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;

    return a.every((value, index) => value === b[index]);
  }

  return false;
}
